// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type MenuExpandIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from menu-expand.svg
 */
export default function MenuExpandIcon(props: MenuExpandIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      data-component="MenuExpandIcon"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.456 11.788 1.226 5.92a.695.695 0 0 1 0-1.025l.726-.684a.804.804 0 0 1 1.087-.001L8 8.861l4.961-4.65a.804.804 0 0 1 1.087.001l.727.684c.3.283.3.742 0 1.025l-6.23 5.867a.804.804 0 0 1-1.09 0z"
      />
    </svg>
  );
}
